import * as React from "react";
import { CurrencyFieldInput } from "../inputs/Normal/currencyFieldInput";
import { DatePickerFieldInput } from "../inputs/Normal/datePickerFieldInput";
import { NumberFieldInput } from "../inputs/Normal/numberFieldInput";
import PercentageFieldInput from "../inputs/Normal/percentageFieldInput";
import { TextFieldInput } from "../inputs/Normal/textFieldInput";
import { YesNoFieldInput } from "../inputs/Normal/yesNoFieldInput";
import { ChoicePicker } from "../inputs/Pickers/choicePicker";
import MultiChoicePicker from "../inputs/Pickers/multiChoicePicker";
import PeoplePickerInput from "../inputs/Pickers/peoplePickerInput";
import TaxonomyPickerInput from "../inputs/Pickers/TaxonomyPickerInput";
import { IAllInputProps } from "../../../../interfaces/advancedSearch/IAllInputProps";
import DatasourceDropdownInput from "../inputs/Datasource/datasourceDropdownInput";
import DatasourceMultiDropdownInput from "../inputs/Datasource/datasourceMultiDropdownInput";
import { InputEnum } from "../../../enums/NormalInputTypeEnum";
import ListLookupPicker from "../inputs/Pickers/listLookupPicker";
import DatasourceTagPickerAdvancedSearch from "../inputs/Datasource/datasourceTagPickerAdvancedSearch";
import DatasourceTextTagPickerInput from "../inputs/Datasource/datasourceTextTagPickerAdvancedSearch";

export class AdvancedSearchInputFactoryHelper {
  static createInput = (inputType: InputEnum, props: IAllInputProps) => {
    switch (inputType) {
      case InputEnum.Text:
        return <TextFieldInput {...props} />;
      case InputEnum.Number:
        return <NumberFieldInput {...props} />;
      case InputEnum.Percentage:
        return <PercentageFieldInput {...props} />;
      case InputEnum.Currency:
        return <CurrencyFieldInput {...props} />;
      case InputEnum.Date:
        return <DatePickerFieldInput {...props} />;
      case InputEnum.YesNo:
        return <YesNoFieldInput {...props} />;
      case InputEnum.peoplePickerSingle:
        return <PeoplePickerInput {...props} />;
      case InputEnum.peoplePickerMultiple:
        return <PeoplePickerInput {...props} />;
      case InputEnum.taxonomySingle:
        return <TaxonomyPickerInput {...props} />;
      case InputEnum.taxonomyDouble:
        return <TaxonomyPickerInput {...props} />;
      case InputEnum.choice:
        return <ChoicePicker {...props} />;
      case InputEnum.multiChoice:
        return <MultiChoicePicker {...props} />;
      case InputEnum.datasourceText:
        return <DatasourceTextTagPickerInput {...props} />
      case InputEnum.datasourceDropdown:
        return <DatasourceDropdownInput {...props} />;
      case InputEnum.datasourceMultipleDropdown:
        return <DatasourceMultiDropdownInput {...props} />;
      case InputEnum.lookupSingle:
        return <ListLookupPicker {...props} />;
      case InputEnum.lookupMulti:
        return <ListLookupPicker {...props} />;
      case InputEnum.datasourceTagPicker:
        return <DatasourceTagPickerAdvancedSearch {...props} />
    }
  };
}
